import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormDebugService {

  static debug(form: FormGroup, formName: string = 'Form'): void {

    console.group(`🔍 ${formName} — ${form.status} (valid: ${form.valid})`);

    const issues: string[] = [];

    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      const info = {
        value: control.value,
        status: control.status,
        errors: control.errors,
        dirty: control.dirty,
        touched: control.touched,
        disabled: control.disabled
      };

      if (!control.valid && !control.disabled) {
        console.warn(`❌ ${key}:`, info);
        issues.push(`${key}: ${JSON.stringify(control.errors)}`);
      } else {
        console.log(`✅ ${key}:`, info);
      }
    });

    if (issues.length) {
      console.warn(`\n⚠️ Blokujące pola (${issues.length}):`, issues);
    } else {
      console.log('\n✅ Wszystkie pola OK');
    }

    console.groupEnd();
  }
}
